module.exports = __webpack_public_path__ + "img/Asset.3028bff9.jpg";